import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=a4c5f8e0&scoped=true&lang=pug"
import script from "./AddEvent.vue?vue&type=script&lang=js"
export * from "./AddEvent.vue?vue&type=script&lang=js"
import style0 from "./AddEvent.vue?vue&type=style&index=0&id=a4c5f8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c5f8e0",
  null
  
)

export default component.exports